import React, { useEffect, useState, useRef } from 'react';
import './TextField.scss'
import DatePicker from "react-datepicker";
import MaskedInput from 'react-text-mask';
import InlineValidation from '../inlineValidation/inlineValidation'
import Required from "../Required";

export const TextField = ({ formik, fieldId, cssField, label, requiredVal = true, maxLength = 20, inputType = 'text', dateField, config, type, format, calendarOpen }) => {

    const [empty, setEmpty] = useState(true)
    const [filled, setFilled] = useState(false)
    const [focused, setFocused] = useState(false)
    const [datePlaceholderLength, setDatePlaceholderLength] = useState(false)

    const currentDateField = useRef(null);

    function emptyTheField() {
        setEmpty(true)
        setFilled(false)
    }

    function formatZip(e) {
        (isNaN(Number(e.key))) && e.preventDefault()
        if (e.target.value.length === 5) {
            e.target.value = e.target.value.concat('-')
        }
    }

    function formatCityState(e) {
        // when user enters input, if it is not a letter or a '-', prevent the input
        if (e.key.length === 1 && !e.key.match(/[a-zA-Z]/) && e.key !== '-') {
            e.preventDefault()
        }
    }
    function formatState(e) {
        if (e.key.length === 1 && !e.key.match(/[a-zA-Z]/) && e.key !== '-') {
            e.preventDefault()
        }
    }
    function formatCity(e) {
        if (!e.key.match(/[a-zA-Z',.\s-]/)) {
            e.preventDefault()
        }
    }

    useEffect(() => {
        const phoneFields = ['PPhone', 'Patient_Phone_Conform', 'RepPhone', 'Rep_Phone_Conform']
        phoneFields.forEach((field) => {
            formik.errors[field] == "Please enter phone number in a valid format" && formik.setFieldValue(field, formik.values[field].replace(/^(\d{3})(\d{3})(\d{4}).*/, "$1-$2-$3"))
        })
    }, [formik.errors.PPhone, formik.errors.Patient_Phone_Conform, formik.errors.RepPhone, formik.errors.Rep_Phone_Conform])


    function blurTheField(e, fieldId) {
        setFocused(false);
        formik.setFieldTouched(fieldId);
        // fieldId.includes('Phone') && console.log("phone:", e.target.value)
        // fieldId.includes('Phone') && e.target.value = 'a'

        e.target.value.length === 0 ? emptyTheField() : setFilled(true)
    }

    function removeExtraSpace(e) {
        if (e.key === 'Backspace') {
            e.target.value.length === 13 && inputType === 'tel' && formik.setFieldValue(fieldId, e.target.value.slice(0, 12))
        }
    }

    useEffect(() => {
        if (currentDateField.current) {
            let dateRequiredIndicator = currentDateField.current
            let dateInput = dateRequiredIndicator.previousElementSibling
            setDatePlaceholderLength(dateInput.placeholder.length)
        }
    })


    const errorOnField = formik.touched[fieldId] && formik.errors[fieldId];

    return (
        <div
            className={`
          form-field 
          text-field 
          ${cssField} 
          ${errorOnField && 'noBottomMargin'}
        `}
            id={fieldId}
        >

            {!dateField ?
                <div className='text-input' style={{ height: errorOnField ? 'auto' : 48 }}>
                    <div className="label-container">
                        <p className='text-label subtitle2'>{label}</p>
                        <Required value={requiredVal} />
                    </div>
                    <input
                        {...formik.getFieldProps(fieldId)}
                        autoComplete={fieldId.includes('Conform') ? "nope" : 'on'}
                        type={inputType}
                        style={{ paddingTop: 0 }}
                        name={fieldId}
                        // autoFocus={fieldId === 'PFName'}
                        onFocus={() => { formik.touched[fieldId] = false; setEmpty(false); setFocused(true) }}
                        onBlur={(e) => { blurTheField(e, fieldId) }}
                        // onKeyPress={(e) => { phoneFaxFormat(e) }}
                        onKeyPress={
                            (e) => {
                                fieldId.includes("Zip") && formatZip(e);
                                (fieldId.includes('Phone') || fieldId.includes('Fax')) && format(e);

                                (fieldId.includes('City')) && formatCity(e);
                                (fieldId.includes('State')) && formatState(e);
                            }
                        }
                        onKeyUp={removeExtraSpace}
                        maxLength={maxLength}
                        className={errorOnField ? 'error-input' : ''}
                       
                    />

                    {empty && <EmptyHint label={label} required={false} />}
                    {(focused || filled) && <FilledHint label={label} required={requiredVal} />}
                </div>
                :
                <div className='text-input' style={{ height: errorOnField ? 'auto' : 48 }}>
                    <div className="label-container">
                        <p className='text-label subtitle2'>{label}</p>
                        <Required value={requiredVal} />
                    </div>
                    <input
                        type='date'
                        placeholder={''}
                        style={{ paddingTop: 0 }}
                        id={cssField}
                        selected={formik.values[fieldId]}
                        name={fieldId}
                        onFocus={(e) => {
                            formik.touched[fieldId] = false; setEmpty(false); setFocused(true);
                        }}
                        onBlur={(e) => {
                            setFocused(false); formik.setFieldTouched(fieldId); e.target.value.length === 0 ? emptyTheField() : setFilled(true);
                        }}
                        className={
                            `${errorOnField && 'error-input'} ${(focused || filled) && 'date-focused'} ${!focused && empty && 'dateInputUnchecked'}`

                        }
                        onChange={date => {
                            formik.setFieldTouched(fieldId, true, true);
                            formik.setFieldValue(fieldId, date.target.value);
                        }}
                        onSelect={date => {
                            formik.setFieldTouched(fieldId, true, true);
                            formik.setFieldValue(fieldId, date.target.value);
                        }}
                    />
                    {/* {!(focused || filled) && <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg" className='date-required-indicator' style={{left: datePlaceholderLength * 6.2 + 11}} ref={currentDateField}><circle cx="2" cy="2" r="1.5" stroke="#B00020" ></circle></svg>} */}
                    {empty && <EmptyHint label={label} required={false} />}
                    {(focused || filled) && <FilledHint label={label} required={requiredVal} />}
                </div>
            }

            {errorOnField && <InlineValidation formik={formik} fieldId={fieldId} fieldTouched={filled} />}
        </div>
    )
}

export default TextField;

const EmptyHint = ({ label, required }) => {
    return (
        <div className='hint empty-hint' style={{ display: 'flex', position: 'relative', bottom: 30, zIndex: -1, paddingLeft: 13 }} >
            <p className='subtitle2' style={{ whiteSpace: "nowrap" }}>{label}</p>
            <Required value={required} />
        </div>
    )
}

const FilledHint = ({ label }) => {
    return (
        <div className='hint filled-hint overline' style={{ display: 'flex', position: 'relative', bottom: 30, marginBottom: 16, fontSize: 12, paddingLeft: 13, textTransform: 'uppercase', }} >
        </div>
    )
}